import React, { useEffect } from "react";

export const addClass = (name) => {
	let data = document.querySelector(name);
	if(document.querySelector(name)) {
		return data.classList
	} else {
		return {
			add: () => {},
			remove: () => {}
		}
	}
}

export const settingsSteps = [
	{
		selector: `#settings-user-general`,
		component: () => {
			return <div>
				<b>General</b>
				Update your general information, please read carefully the texts below both Username and Email in order to avoid any unexpected result.
			</div>
		}
	},
	{
		selector: `#settings-user-personal`,
		component: () => {
			return <div>
				<b>Business Details</b>
				Update your business details to access the payment features on our website. Please be sure to use real and identifiable information in order to avoid getting your account locked.
			</div>
		}
	},
	{
		selector: `#settings-user-security`,
		component: () => {

			return <div>
				<b>Security</b>
				Change your password, regenerate your API Key, enable email 2FA or OTP.
			</div>
		}
	},
	{
		selector: `#settings-user-notifications`,
		component: () => {
			return <div>
				<b>Notifications</b>
				Review the notification settings, enable emails for Orders/Tickets/Feedback/Replies and connect your Discord server for real time notifications there.
			</div>
		}
	},
	{
		selector: `#settings-user-shop`,
		component: () => {
			return <div>
				<b>Create Shop</b>
				Create an additional shop under your primary business. <br/>
				A limit of 2 shops is applied for users on a free plan, in order to create more than 2 shops the Pro or Business subscription is required.
			</div>
		}
	},


	{
		selector: `#settings-shop-general`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>General</b>
				Update the general settings and information of the shop you've currently selected. <br/>
				These updates immediately reflect on your storefront. <br/>
				With the "On Hold" option you can temporarily set your shop on hold and block purchases till you're good to go again!
			</div>
		}
	},
	// {
	// 	selector: `#settings-shop-terms`,
	// 	preferredModalPosition: 'top',
	// 	component: () => {
	// 		return <div>
	// 			<b>Terms</b>
	// 			Insert your Terms of Service, which will be displayed on both the shop's storefront and at the moment of checkout.
	// 		</div>
	// 	}
	// },
	{
		selector: `#settings-shop-payments`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Payments</b>
				Check out every payment method available on our platform: from cryptocurrencies to PayPal, Stripe and PerfectMoney. <br/>
				More detailed information about each payment method can be found in the texts below and/or above inputs.
			</div>
		}
	},
	{
		selector: `#settings-shop-crypto`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Cryptocurrencies</b>
				Configure your crypto addresses to receive instant and scheduled payouts from completed invoices.
			</div>
		}
	},
	{
		selector: `#settings-shop-cart`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Shopping Cart</b>
				General settings regarding our Shopping Cart feature, available for Pro and Business users.
			</div>
		}
	},
	{
		selector: `#settings-shop-subscription`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Subscription</b>
				Enable your customers to purchase a product with a recurring payment. <br/>
				We will handle all the logic, you only need to setup a webhook to match business needs.
			</div>
		}
	},
	{
		selector: `#settings-shop-design`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Design</b>
				Configure the general design of your shop, add social links such as instagram, tiktok, reddit, facebook and more! <br/>
				You can also update the default sizes for images displayed on your storefront, as well as opting in for our Dark Theme and many other things.
			</div>
		}
	},
	{
		selector: `#settings-shop-managers`,
		preferredModalPosition: 'top',
		component: () => {

			useEffect(() => {
				window.localStorage.setItem("onboardingSettings", "true");
			}, [])

			return <div>
				<b>Managers</b>
				Add, remove or update managers for your shop. <br/>
				With grained permissions you can set exactly which actions should a manager have access to in order to help you manage your business.
			</div>
		}
	},
]

export const dashboardSteps = [
	{
		selector: `.user-menu-trigger`,
		preferredModalPosition: 'left',
		component: () => {
			return <div>
				<b>Profile and Quick Actions</b>
				Access your profile and quick action links: go to the dashboard, your shop, payment settings or general settings.
			</div>
		}
	},
	{
		selector: `#referrals`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'left',
		component: () => {

			useEffect(() => {
				let menu = addClass('.custom-animation');
				menu.add('flex');
				menu.remove('hidden');

				return () => {
					menu.remove('flex');
					menu.add('hidden');
				}
			}, []);

			return <div>
				<b>Affiliate Link</b>
				In under 2 minutes, you'll be able to start your own side hustle to generate an income stream up to 5% of the cashflow that requires zero upfront costs. <br/>
				Anyone, anywhere, can sign up and invite.
			</div>
		}
	},
	{
		selector: `#subscription`,
		preferredModalPosition: 'left',
		component: () => {

			useEffect(() => {
				let menu = addClass('.custom-animation');
				menu.add('flex');
				menu.remove('hidden');

				return () => {
					menu.remove('flex');
					menu.add('hidden');
				}
			}, []);

			useEffect(() => {
				let menu = addClass('#subscription .nav-dropdown-items');
				menu.add('open');

				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Subscription</b>
				Know when your subscription expires or get to know the details for each one of them, easily upgrade your plan with just a few clicks!
			</div>
		}
	},
	{
		selector: `.color-switch`,
		preferredModalPosition: 'left',
		component: () => {
			return <div>
				<b>Theme Preference</b>
				Join the dark side or live in the light with our theme toggle option.
			</div>
		}
	},
	{
		selector: `.notification-menu`,
		preferredModalPosition: 'left',
		component: () => {
			return <div>
				<b>Notifications</b>
				Important notifications will be delivered here. <br/>
				To set up emails and Discord notifications too you can update your settings through the apposite page, which you can learn more about here.
			</div>
		}
	},
	{
		selector: `#all-reports`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Analytics Summary</b>
				A quick summary of the most important analytics of your selected period.
			</div>
		}
	},
	{
		selector: `#dashboard-graph`,
		preferredModalPosition: 'top',
		component: () => {
			return <div>
				<b>Revenues and Orders chart</b>
				In depth graph of your revenues and orders for the period you have selected. <br/>
				Hover it with your mouse in order to see the exact number of Revenue and Orders.
			</div>
		}
	},
	{
		selector: `.sidebar-container`,
		preferredModalPosition: 'right',
		component: () => {
			return <div>
				<b>Sidebar</b>
				Access every other Paylix feature through the sidebar. <br/>
				For a deeper tutorial, visit the page you want to know more about and click the tutorial icon.
			</div>
		}
	},
	{
		selector: `#products`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				let menu = addClass('#products .nav-dropdown-items');
				menu.add('open');


				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Products</b>
				Create your business products, groups and categories. <br/>
				Access our sorting function and utils to quickly update multiple products at once. <br/>
				Create coupons for your products with multiple variables in place.
			</div>
		}
	},
	{
		selector: `#invoices`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				let menu = addClass('#invoices .nav-dropdown-items');
				menu.add('open');


				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Invoices</b>
				Go through your orders, from first to last. <br/>
				Here you can also find PayPal opened disputes, and Monthly bill dashboard.
			</div>
		}
	},
	{
		selector: `#analytics`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				let menu = addClass('#analytics .nav-dropdown-items');
				menu.add('open');


				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Analytics</b>
				Access more complete analytics for your business and create reports in a matter of seconds.
			</div>
		}
	},
	{
		selector: `#comms`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				let menu = addClass('#comms .nav-dropdown-items');
				menu.add('open');

				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Feedback</b>
				The feedback given by your customers to you. <br/>
				You can then close, reply or reopen each one of them. <br/>
				Query opened by your customers on your shop. <br/>
				With our Pro and Business plan you can also appeal bad feedback given without a proper reason.
			</div>
		}
	},
	{
		selector: `#customization`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				let menu = addClass('#customization .nav-dropdown-items');
				menu.add('open');

				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Customization</b>
				For Pro and Business users only, fully customize the appearance of your shop, from grown up. <br/>
				Create your own custom domain (yourBusiness.paylix.gg) and add any additional domain you might need to access your storefront through a unique name. <br/>
				You also receive a custom domain (yourBusiness.paylix.gg).
			</div>
		}
	},
	{
		selector: `#fraud_shield`,
		track: true,
		trackFrequency: 0,
		preferredModalPosition: 'top',
		component: () => {

			useEffect(() => {
				let menu = addClass('#fraud_shield .nav-dropdown-items');
				menu.add('open');

				return () => {
					menu.remove('open');
				}
			}, []);


			return <div>
				<b>Fraud Shield</b>
				Available for Pro (with limitations) and Business (fully) users only: access our security features, tailor made to keep your business secure. <br/>
				Detect malicious log ins, require 2FA for your managers, Lockdown your account to a specific country only, review every session created in your name and a full audit trail of any action of yours. <br/>
				Additionally, automatically blacklist fraud attempts and access both Shared and Private blacklists, as well as a customizable whitelist.
			</div>
		}
	},
	{
		selector: `#developers`,
		track: true,
		trackFrequency: 20,
		preferredModalPosition: 'top',
		component: () => {


			useEffect(() => {
				let menu = addClass('#developers .nav-dropdown-items');
				menu.add('open');

				return () => {
					menu.remove('open');
				}
			}, []);

			return <div>
				<b>Developers</b>
				Mainly for developers, you can find our developer docs (developers.paylix.gg), check out how our Embed System works and access your webhook logs and simulator.
			</div>
		}
	},
	{
		selector: `#minimized`,
		preferredModalPosition: 'right',
		component: () => {

			useEffect(() => {
				window.localStorage.setItem("onboardingDashboard", "true");
			}, [])

			return <div>
				<b>Minimize</b>
				Hide the menu to get more space.
			</div>
		}
	}
];